import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import features from 'src/data/features.js';

class List extends Component {
  state = {
    activeIndex: 0,
  };

  handleClick = index => {
    this.setState({ activeIndex: index });
  };

  render() {
    const { activeIndex } = this.state;

    return features.map((feature, index) => (
      <Root
        key={feature.title + index}
        active={activeIndex === index}
        onClick={() => this.handleClick(index)}
      >
        <Title>{t(feature.title)}</Title>
        <ListWrapper active={activeIndex === index} count={feature.list.length}>
          {feature.list.map((item, indexI) => {
            if (typeof item === 'object') {
              return (
                <ul key={indexI}>
                  {item.map((subItem, indexJ) => (
                    <SubItem key={indexI + indexJ}>{t(subItem)}</SubItem>
                  ))}
                </ul>
              );
            } else {
              return <Item key={indexI}>{t(item)}</Item>;
            }
          })}
        </ListWrapper>
      </Root>
    ));
  }
}

const Root = styled.div`
  border-top: 1px solid #e8e8e8;
  padding: 20px 0px;
  position: relative;
  &::before {
    content: '';
    background: url(${require('src/assets/images/interiors/triangle.png')});
    width: 29px;
    height: 13px;
    position: absolute;
    top: 20px;
    right: 36px;
    transform: ${props => (props.active ? 'scaleY(-1)' : 'scaleY(1)')};
    transition: all 0.4s ease-out;
  }
  &:last-child {
    border-bottom: 1px solid #e8e8e8;
  }
`;

const Title = styled.h5`
  font-size: 18px;
  color: #967557;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
`;

const ListWrapper = styled.ul`
  margin-top: ${props => (props.active ? '20px' : '0')};
  max-height: ${props => (props.active ? `${props.count * 100}px` : '0')};
  opacity: ${props => (props.active ? 1 : 0)};
  transition: all 0.4s ease-out;
  overflow: hidden;
`;

const Item = styled.li`
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 19px;
  list-style-type: disc;
  font-size: 14px;
  width: 57%;
  margin-left: 17px;
  @media (max-width: ${media.md}) {
    width: 90%;
  }
`;

const SubItem = styled.li`
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 19px;
  list-style-type: disc;
  list-style-type: square;
  font-size: 13px;
  width: 57%;
  margin-left: 30px;
  @media (max-width: ${media.md}) {
    width: 80%;
  }
`;

export default List;



// WEBPACK FOOTER //
// ./src/pages/Interiors/elements/Accordion/elements/List.js